var $ = require('jquery');

module.exports = (function() {

})();
